// Asset presenti nel public/ del B2B e non (ancora) su goooled.it: serviti dall'API del B2B.
const LOCAL_ASSETS = {
    'images/battiscopa.jpg': '/api/products/local-asset/battiscopa.jpg',
    'drawings/battiscopa_tech.png': '/api/products/local-asset/battiscopa_tech.png',
    'images/battiscopa_bianco.jpg': '/api/products/local-asset/battiscopa_bianco.jpg',
    'images/battiscopa_nero.jpg': '/api/products/local-asset/battiscopa_nero.jpg',
    'images/battiscopa_grigio.jpg': '/api/products/local-asset/battiscopa_grigio.jpg',
    'images/battiscopa_champagne.jpg': '/api/products/local-asset/battiscopa_champagne.jpg',
    'images/battiscopa_angolare_int.jpg': '/api/products/local-asset/battiscopa_angolare_int.jpg',
    'images/battiscopa_angolare_ext.jpg': '/api/products/local-asset/battiscopa_angolare_ext.jpg',
    'images/battiscopa_clips.jpg': '/api/products/local-asset/battiscopa_clips.jpg',
    'images/bmn.jpg': '/api/products/local-asset/bmn.jpg',
    'drawings/bmn_tech.png': '/api/products/local-asset/bmn_tech.png',
    'images/bmn_z8.jpg': '/api/products/local-asset/bmn_z8.jpg',
    'images/bmn_z9.jpg': '/api/products/local-asset/bmn_z9.jpg',
    'images/bmn_r010.jpg': '/api/products/local-asset/bmn_r010.jpg',
    'images/bmn_kit_sosp.jpg': '/api/products/local-asset/bmn_kit_sosp.jpg',
    'images/bmn_graff_sosp.jpg': '/api/products/local-asset/bmn_graff_sosp.jpg',
    'images/bmn_diss.jpg': '/api/products/local-asset/bmn_diss.jpg',
    'images/bmn_bianco.jpg': '/api/products/local-asset/bmn_bianco.jpg',
    'images/bmn_nero.jpg': '/api/products/local-asset/bmn_nero.jpg',
    'images/bmn_grigio.jpg': '/api/products/local-asset/bmn_grigio.jpg',
    'images/rosone_mini_bianco_conico.jpg': '/api/products/local-asset/rosone_mini_bianco_conico.jpg',
    'images/rosone_mini_nero_conico.jpg': '/api/products/local-asset/rosone_mini_nero_conico.jpg',
    'images/kit_sospensione_universale.jpg': '/api/products/local-asset/kit_sospensione_universale.jpg',
};

let urlAsset = (n) => {
    n = n.split("goooled.it").pop();
    n = n.split("/").filter(e => (e ?? "").trim() !== "").join("/");
    // Solo ARAKY: asset verificati serviti dal B2B invece dei vecchi link CDN.
    if (/^drawings\/araki_tech\.(?:jpg|png)$/i.test(n)) {
        return '/api/products/araky/drawing-v2.png';
    }
    if (/^datasheet\/Araki2126\.pdf$/i.test(n)) {
        return '/api/products/araky/datasheet-v2.pdf';
    }
    if (LOCAL_ASSETS[n]) {
        return LOCAL_ASSETS[n];
    }
    return (new URL(n, "https://www.goooled.it")).toString();
}

export {
    urlAsset,
};
